import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
let ComingSoon = class ComingSoon extends Vue {
    constructor() {
        super(...arguments);
        this.key = '';
    }
};
ComingSoon = __decorate([
    Component({
        components: {
            PageTitle,
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$data.key = to.name;
                return true;
            });
        },
        beforeRouteUpdate(to, from, next) {
            this.$data.key = to.name;
            next();
        },
    })
], ComingSoon);
export default ComingSoon;
